import Logo from "./logo";

export const ScreenSaver = () => {
  return (
    <div className="absolute inset-0 z-[99999999] overflow-hidden flex items-center justify-center bg-black">
      <div className="w-[80vw] h-[80vh]">
        <Logo className="w-full h-full animate-pulse-slow" />
      </div>
    </div>
  );
};
